import React from 'react';

import { Button } from 'react-bootstrap';

import { BookingOption } from '../../../types/Activity';

import EditOrderBookingOptions from './EditOrderBookingOptions';

type Props = {
  options: BookingOption[];
  addBookingOption: (option: BookingOption) => void;
};

const ActivityBookingOptionsList = (props: Props) => {
  const addBookingOptionAction = (option: BookingOption) => {
    return (
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <Button
          type='submit'
          className='submit'
          bsStyle='primary'
          onClick={() => props.addBookingOption(option)}
        >
          <i className='fas fa-plus' />
        </Button>
      </div>
    );
  };

  return (
    <EditOrderBookingOptions
      options={props.options}
      uiElements={{
        action: addBookingOptionAction,
      }}
    />
  );
};

export default ActivityBookingOptionsList;
